import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_select, {
            items: _ctx.hours,
            "item-title": "title",
            "item-value": "value",
            variant: "outlined",
            suffix: "時",
            density: "compact",
            "hide-details": "auto",
            modelValue: _ctx.inputHour,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputHour) = $event)),
            color: "primary"
          }, null, 8, ["items", "modelValue"]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mx-2" }, " : ", -1)),
          _createVNode(_component_v_select, {
            items: _ctx.minutes,
            "item-title": "title",
            "item-value": "value",
            variant: "outlined",
            suffix: "分",
            density: "compact",
            "hide-details": "auto",
            modelValue: _ctx.inputMinute,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputMinute) = $event)),
            color: "primary"
          }, null, 8, ["items", "modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}